import { render, staticRenderFns } from "./App.vue?vue&type=template&id=22c03c40&scoped=true&"
var script = {}
import style0 from "./styles/app.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./App.vue?vue&type=style&index=1&id=22c03c40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c03c40",
  null
  
)

export default component.exports